import { Rect } from 'dragonmouse-shared/geometry';
import styled from 'styled-components';

interface SvgContainerProps {
	sceneBounds: Rect;
}
export const SvgContainer = styled.svg<SvgContainerProps>`
	position: absolute;
	top: ${(p) => p.sceneBounds.y}px;
	left: ${(p) => p.sceneBounds.x}px;
	width: ${(p) => p.sceneBounds.width}px;
	height: ${(p) => p.sceneBounds.height}px;
`;
